// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c4ce2352","573":"cce33b37","703":"1851afa4","787":"baed138b"}[chunkId] + ".chunk.js";
};